export type ManualErrorType =
  | "accurately classify"
  | "analyze text from"
  | "combine images"
  | "compress images"
  | "extract text from"
  | "generate upload URL for"
  | "process"
  | "process files"
  | "upload"
  | "upload file"
  | "upload multiple files";

export const MANUAL_ERROR_MESSAGES: Record<ManualErrorType, string> = {
  "accurately classify":
    "The Axle service could not accurately classify the uploaded document",
  "analyze text from":
    "The Axle service could not analyze text from the uploaded document",
  "combine images": "The Axle service could not combine the uploaded images",
  "compress images":
    "The Axle service could not compress the uploaded image. Try uploading another image.",
  "extract text from":
    "The Axle service could not extract text from the uploaded document",
  "generate upload URL for":
    "The Axle service could not generate an upload URL for the document",
  process: "The Axle service could not process the uploaded document",
  "process files": "The Axle service could not process the uploaded files",
  upload: "The Axle service could not upload the document",
  "upload file": "The Axle service could not upload the file",
  "upload multiple files": "The Axle service could not upload multiple files",
};
